import apiDriveAdresseLad from "@/services/http/api-drive/client/adresseLad";
import { useCheckoutStore } from "@/store/checkout";

export const useContainerAdressesLad = () => {
  const app = useNuxtApp();
  const checkoutStore = useCheckoutStore();
  const { addresseLad: adresseLadCheckout } = storeToRefs(checkoutStore);
  const { setAddresseLad: setAdresseLadCheckout } = checkoutStore;

  const adresseLad = ref(null)
  const error = ref(null)
  const isLoading = ref(false)

  const update = async (addresse) => {
    error.value = null;
    if (!adresseLad.value) {
      adresseLad.value = { ...adresseLadCheckout.value };
    }
    adresseLad.value.attributes = addresse;
    try {
      const { data } = await app.$apiDrive
        .use(apiDriveAdresseLad)
        .update(adresseLad.value.id, adresseLad.value.attributes);
      // Si c'est la même adresse que dans le store checkout, il faut la mettre à jour
      // l'édition d'adresse change son ID...
      if (
        adresseLadCheckout.value &&
        adresseLad.value.id === adresseLadCheckout.value.id
      ) {
        setAdresseLadCheckout(data);
      }
    } catch (err) {
      handleError(err);
    }
  }

  const handleError = (err) => {
    error.value = app.$apiDrive.getErrorData(err);
  }

  return {
    adresseLad,
    error,
    isLoading,
    update,
    handleError
  }
};